<template>
    <div class="add-ending-select-page" id="add-ending-select-page">
        <app-loading 
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="$router.push('/add-ending')"
            @clickMenu="change_menu(context, true)"
        />

        <div class="video-page__image"></div>

        <div class="add-ending-select-page__container">
            <div class="add-ending-select-page__title"
                v-if="!temporaryData"
            >
                Выберите концовку
            </div>

<!--            <app-player-->
<!--                :id="temporaryData.id"-->
<!--                :video="temporaryData.video"-->
<!--                :webm="temporaryData.webm"-->
<!--                @playVideo="entry_play_video()"-->
<!--            />-->

          <app-player-no-blob
              :id="temporaryData.id"
              :video="temporaryData.video"
              :webm="temporaryData.webm"
              @playVideo="entry_play_video()"
          />
        </div>

        <div class="add-ending-select-page__footer" id="add-ending-select-page__footer">
          <carousel
              :per-page="3"
              :mouse-drag="true"
              :paginationEnabled="false"
              :navigateTo="0"
              :spacePadding="16"
          >
            <slide
                v-for="(item, index) in videos"
                :key="item.id"
            >
              <app-one-video
                  :key="`${item.id}__index`"
                  :index="index"
                  :id="item.id"
                  :name="item.name"
                  :text="item.text"
                  :img="item.img"
                  :status="item.status"
                  :textStatus="true"
                  :duration="item.duration"
                  :video="item.video"
                  :type="item.type"
                  :control="item.control"
                  :webm="item.webm"
                  :coef="item.coef"
                  width="108px"
                  height="108px"
                  @clickVideo="(data) => ending_click_video(context, data)"
              />
            </slide>
          </carousel>
            <div class="add-ending-select-page__button"
                v-if="!editeableItem && (videosStore[videosStore.length - 1].control !== 'ending')"
                :class="{ 'add-ending-select-page__button-active' : temporaryData}"
                @click="entry_add_video(context, { store_url: 'ending_video/setVideos', redirect: '/survey' })"
            >
                <div class="add-ending-select-page__button-text"
                    :class="{'add-ending-select-page__button-text-active' : temporaryData}"
                >
                    Добавить видео
                </div>
            </div>

            <div class="add-ending-select-page__button"
                v-if="editeableItem || (videosStore[videosStore.length - 1].control === 'ending')"
                :class="{ 'add-ending-select-page__button-active' : temporaryData}"
                @click="entry_add_video(context, { store_url: 'ending_video/setVideos', redirect: '/survey' })"
            >
                <div class="add-ending-select-page__button-text"
                    :class="{'add-ending-select-page__button-text-active' : temporaryData}"
                >
                    Заменить видео
                </div>
            </div>
        </div>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="Вернуться на главную"
            :text="error.text"
            @clickGrowButtonPopup="$router.push('/')"
        />

      </transition>

    </div>
</template>

<script>

    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppOneVideo = () => import('@/components/one-video.vue')
    const AppPlayer = () => import('@/components/player.vue')
    const AppAlert = () => import('@/components/popups/error')
    const AppPlayerNoBlob = () => import('@/components/onePlayerNoBlob')

    import { Carousel, Slide } from 'vue-carousel';

    import ending_mounted_hook from "@/views/add_ending_select/modules/ending_mounted_hook";
    import change_menu from "@/views/theme/modules/change_menu";
    import ending_click_video from "@/views/add_ending_select/modules/ending_click_video";
    import entry_play_video from "@/views/entry/modules/entry_play_video";
    import entry_add_video from "@/views/entry/modules/entry_add_video";

    export default {
        async mounted() {
          await this.ending_mounted_hook(this)
        },
        destroyed() {
          this.$store.dispatch('cache_videos_page_context/clearCacheVideo')
        },
        data() {
            return {
                context: this,
                menu: false,
                overlay: false,
                rendering: false,
                videos: [],
                temporaryData: false,
                swiperOption: {
                    slidesPerView: 2.6,
                    spaceBetween: 30,
                    width: 300,
                    centeredSlides: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                },
                error: {
                  status: false,
                  text: ''
                }
            }
        },
        components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            AppOneVideo,
            AppPlayer,
            AppAlert,
            Carousel,
            Slide,
            AppPlayerNoBlob
        },
        computed: {
            loading() {
              return !(this.videos.length > 0 && this.rendering)
            },
            editeableItem() {
                return this.$store.getters['edit/editableItem']
            },
            videosStore() {
                return this.$store.getters['main_videos/main']
            }
        },
        methods: {
          ending_mounted_hook,
          change_menu,
          ending_click_video,
          entry_add_video,
          entry_play_video,
        }
    }
</script>

<style lang="less">

    .add-ending-select-page {
        background-color: black;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    }

    #add-ending-select-page .header-component {
        z-index: 10;
    }

    .video-page__image {
        background-image: url('../../assets/space.jpg');
        display: none;
    }

    .add-ending-select-page__container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #add-ending-select-page .player-component {
        position: absolute;
    }

    #add-ending-select-page .VueCarousel {
      min-height: 116px;
      //min-width: 360px;
    }


    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .add-ending-select-page__title {
        color: #FFFFFF;
        line-height: 28px;
        font-size: 22px;
        font-family: 'Montserrat-Bold';
        text-align: center;
    }

    .add-ending-select-page__footer {
        width: 100%;
        background-color: #2F1F4C;
        position: relative;
        z-index: 10;
    }

    #add-ending-select-page__footer .VueCarousel-wrapper {
      padding-top: 16px;
    }

    #add-ending-select-page__footer .VueCarousel-slide {
      max-width: 131px;
      min-width: 131px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .add-ending-select-page__button {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 12px;
        margin-left: 16px;
        margin-right: 16px;
        margin-bottom: 16px;
        cursor: pointer;
    }

    .add-ending-select-page__button-text {
        font-family: 'Montserrat-Medium';
        opacity: .5;
        color:  #FFFFFF;
        line-height: 12px;
        font-size: 16px;
    }

    .add-ending-select-page__button-active {
        background: #FFFFFF;
    }

    .add-ending-select-page__button-text-active {
        color: #31283D;
        opacity: 1;
    }
</style>